import { FC, Dispatch, useState, useEffect } from "react";
import { FormatDateFE } from "../../../helper/general/methods";
import { UserDecisionInterface } from "../../../middleware/interfaces/user/user-decision-interface";
import { FolderInterface } from "../../../middleware/interfaces/folder/folder-interface";
import { UserInterface } from "../../../middleware/interfaces/user/user-interface";
import { FolderDeleteInterface } from "../../../middleware/interfaces/folder/folder-delete-interface";
import { FolderDownloadInterface } from "../../../middleware/interfaces/folder/folder-download-interface";
import { PingServerWithLastActionDate } from "../../../helper/ui/methods";
import MenuButton from "../user/menu-button";

interface folderInfoProps {
  user: UserInterface;
  selectedFolder: FolderInterface;
  setSelectedFolder: Dispatch<any>;
  setFolderEditDialogReveal: Dispatch<any>;
  dispatch: Dispatch<any>;
}

const FolderInfo: FC<folderInfoProps> = ({
  user,
  selectedFolder,
  setSelectedFolder,
  setFolderEditDialogReveal,
  dispatch,
}) => {
  const [openFolder, setOpenFolder] = useState(false);
  const [folderDeleteDialogReveal, setFolderDeleteDialogReveal] =
    useState(false);
  const [folderDownload, setFolderDownload] = useState(false);
  const [folderEdit, setFolderEdit] = useState(false);

  useEffect(() => {
    if (openFolder === true) {
      const updatedUser = {
        ...user,
        openFolder: selectedFolder,
      };
      dispatch({
        type: "UPDATE_USER",
        payload: updatedUser,
        response: "",
      });
      //PING SERVER TO UPDATE THE SESSION
      PingServerWithLastActionDate(updatedUser!);
      setOpenFolder(false);
      setSelectedFolder(null);
    }
  }, [openFolder]);

  useEffect(() => {
    if (folderDeleteDialogReveal) {
      const deleteFolderData: FolderDeleteInterface = {
        email: user.email,
        folderID: selectedFolder.folderID,
        projectID: user.openProject?.projectID!,
        projectUserRole: user.openProject?.projectUserRole!,
        type: "FolderDeleteInterface",
      };
      const decision: UserDecisionInterface = {
        title: `Delete ${selectedFolder.folderName}?`,
        message:
          "The folder and everything inside it will be removed. This cannot be undone.",
        confirmLabel: "Delete",
        decisionOptions: ["DELETE_FOLDER", "NO_ACTION"],
        result: "",
        data: deleteFolderData,
        type: "UserDecisionInterface",
      };
      dispatch({ type: "DECISION", decision: decision });
    }
    setFolderDeleteDialogReveal(false);
  }, [folderDeleteDialogReveal]);

  useEffect(() => {
    if (folderDownload === true) {
      const downloadFolderData: FolderDownloadInterface = {
        email: user.email,
        projectUserRole: user.openProject!.projectUserRole,
        folderID: selectedFolder.folderID,
        projectID: selectedFolder.projectID,
        type: "FolderDownloadInterface",
      };
      const decision: UserDecisionInterface = {
        title: `Download ${selectedFolder.folderName}?`,
        message:
          "The folder is bundled in your browser and saved to your computer.",
        confirmLabel: "Download",
        decisionOptions: ["DOWNLOAD_FOLDER", "NO_ACTION"],
        result: "",
        data: downloadFolderData,
        type: "UserDecisionInterface",
      };
      dispatch({ type: "DECISION", decision: decision });
    }
    setFolderDownload(false);
  }, [folderDownload]);

  useEffect(() => {
    if (folderEdit === true) {
      setFolderEditDialogReveal("EDIT");
    }
    setFolderEdit(false);
  }, [folderEdit]);

  return (
    <>
      {(() => {
        if (selectedFolder) {
          return (
            <div className="itemDetails">
              <div className="itemDetailsHeader">
                <img
                  className="icon-medium"
                  src="assets/icons/folder.png"
                  draggable="false"
                  alt={selectedFolder.folderName}
                />
                <div className="itemDetailsIdentity">
                  <span className="itemDetailsName">
                    {selectedFolder.folderName}
                  </span>
                  <span className="itemDetailsSubtitle">Folder</span>
                </div>
                <span
                  className="itemDetailsClose"
                  onClick={() => {
                    setSelectedFolder(null);
                  }}
                >
                  ×
                </span>
              </div>
              <div className="itemDetailsMetadata">
                <span className="itemDetailsLabel">CREATED</span>
                <span className="itemDetailsValue">
                  {FormatDateFE(selectedFolder.folderCreationDate!, true)}
                </span>
                <span className="itemDetailsLabel">BY</span>
                <span className="itemDetailsValue">
                  {selectedFolder.folderCreatedBy}
                </span>
              </div>
              <div className="itemDetailsActions">
                <MenuButton
                  imageSource="assets/icons/enter.png"
                  alternativeText="Enter"
                  buttonSize="small"
                  buttonAccent="primary"
                  dispatch={() => {
                    setOpenFolder(true);
                  }}
                />
                <MenuButton
                  imageSource="assets/icons/download.png"
                  alternativeText="Download"
                  buttonSize="small"
                  dispatch={() => {
                    setFolderDownload(true);
                  }}
                />
                <MenuButton
                  imageSource="assets/icons/edit.png"
                  alternativeText="Edit"
                  buttonSize="small"
                  dispatch={() => {
                    setFolderEdit(true);
                  }}
                />
                <MenuButton
                  imageSource="assets/icons/delete.png"
                  alternativeText="Delete"
                  buttonSize="small"
                  buttonAccent="destructive"
                  dispatch={() => {
                    setFolderDeleteDialogReveal(true);
                  }}
                />
              </div>
            </div>
          );
        } else {
          return <></>;
        }
      })()}
    </>
  );
};

export default FolderInfo;
